import { CART } from '../actions/cart';

const cart = (state = null, { type, payload }) => {
  switch (type) {
    case CART:
      return payload;
    default:
      return state;
  }
};

export default cart;
